import UNIQUE from '@/common/unique'

import store from '@/stores/'
const langValue = function () {
  return Object.assign({}, store.state.setting.lang.langValue)
}

export default {
  id: 'flexible',
  name: 'flexible',
  type: 'standard',
  moduleName: 'editor_module_flexible',
  dataSet: {
    mods: 'flexible',
    column: []
  },
  setting: {
    layout: {
      options: [
        'link',
        'fullsize',
        'columns',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
